import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from './PageContext';
import redMinusIcon from '../../svgs/delete-bin-icon.svg';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import PageReadOnlyInput from './PageReadOnlyInputCopy.jsx'; 
import TableInput from './TableInputCopy.jsx'; 
import TableDropdown from './TableDropdownWithObjCopy.jsx'; 
import TableAutocomplete from './TableAutocompleteCopy.jsx';
import { Button, TableCell, Typography } from '@mui/material';
import addIcon from '../../svgs/plus-icon.svg';

const AddNewRebateSetupRow = ({row, count, tableHeader}) =>{
    // get context from parent
    const {
        rebateSetupDataList, 
        setRebateSetupDataList, 
        feeCategoryDescriptionList, 
        productTypeList, 
        billingRateList,  
        subCompanyIdsList, 
        masterTierIdsList, 
        setMasterTierIdsList, 
        setupToAllSubs,
        rebateSetupErrorList, 
        setRebateSetupErrorList,
        rebateInputTypeId, 
        rebateSetupDataListLength, 
        setRebateSetupDataListLength, 
        activeList, 
        rebateSetupTypeList
    } = useContext(PageContext);

    // set state
    const [setupId, setSetupId] = useState(count+1); // setup id will always be count+1 (this is for adding identity column into database if master tier for another row)
    const [masterSetupBool, setMasterSetupBool] = useState(false); 
    const [rateTag, setRateTag] = useState('Rate'); 

    // return null if empty string
    const nullIfEmpty = ( str ) => {
        if (str != null && str.length == 0){
            return null; 
        }
        else {
            return str; 
        }
    }

    // add row from data list
    const addRebateSetup = () =>{
        // create header object
        let temp2 = []; 
        for (let i = 0; i < tableHeader.length; i++){
            temp2.push(tableHeader[i]['columnname']);
        }
        // get most recent row 
        let prevRow = null; 
        for (let i = count - 1; i >= 0; i--) {
            if (rebateSetupDataList[i]) {
                prevRow = rebateSetupDataList[i]; 
            }
        }
        // if there is a previous row get sub company id, master tier id, product, fee category, billing rate and days to pay from that row 
        let temp = {};
        if (prevRow){
            // build object
            temp2.map((el) => {
                if (el == 'blank'){
                    temp[el] = false;
                }
                else if (el == 'active'){
                    temp[el] = activeList[0];
                }
                else if (el == 'companyid'){
                    temp[el] = prevRow['companyid']; 
                }
                else if (el == 'masterincentivesetupid'){
                    temp[el] = prevRow['masterincentivesetupid']; 
                }
                else if (el == 'producttypeid'){ 
                    temp[el] = prevRow['producttypeid'];
                }
                else if (el == 'feecategoryid'){
                    temp[el] = prevRow['feecategoryid']; 
                }
                else if (el == 'billingrateid'){
                    temp[el] = prevRow['billingrateid']; 
                }
                else if (el == 'incentivesetupid') {
                    temp[el] = count+1;
                }
                else if (el == 'mastersetupbool') {
                    temp[el] = prevRow['mastersetupbool']; 
                }
                else if (el == 'rebatesetuptypeid') {
                    temp[el] = prevRow['rebatesetuptypeid']; 
                }
                else {
                    temp[el] = '';
                }
            }); 
        }
        // if no previous row all values are default 
        else{
            // build object
            temp2.map((el) => {
                if (el == 'blank'){
                    temp[el] = false;
                }
                else if (el == 'active'){
                    temp[el] = activeList[0];
                }
                else if (el == 'feecategoryid' || el == 'producttypeid' || el == 'billingrateid'){
                    temp[el] = '';
                }
                else if (el == 'incentivesetupid') {
                    temp[el] = count+1;
                }
                else if (el == 'mastersetupbool') {
                    temp[el] = false; 
                }
                else if (el == 'masterincentivesetupid'){
                    temp[el] = null; 
                }
                else{
                    temp[el] = '';
                }
            });
        }
        // assign object to state 
        let tempObj = rebateSetupDataList; 
        // move bottom row to end of object
        tempObj[(count+1)] = rebateSetupDataList[count]; 
        // set new element 
        rebateSetupDataList[count] = temp; 
        setRebateSetupDataList(rebateSetupDataList => rebateSetupDataList = tempObj);
        // set error object 
        let temp5 = {}
        Object.keys(temp2).map((el) => {
            temp5 = {
                ...temp5, 
                el: false, 
            }
        }); 
        // add error object to sub company error list 
        setRebateSetupErrorList(rebateSetupErrorList => rebateSetupErrorList = [
            ...rebateSetupErrorList.slice(0, rebateSetupErrorList.length-1), 
            temp5, 
            ...rebateSetupErrorList.slice(rebateSetupErrorList.length-1, rebateSetupErrorList.length)
        ]); 
        // increment length
        setRebateSetupDataListLength(rebateSetupDataListLength => rebateSetupDataListLength = rebateSetupDataListLength + 1); 
    }

    // remove row from data list 
    const removeRebateSetup = (index) =>{
        // set tempObj 
        let tempObj = rebateSetupDataList; 
        // remove row at index
        let length = 0; 
        Object.keys(tempObj).map(el => {
            let num = parseInt(el); 
            // set length; 
            length = num; 
            // overwrite element
            if ( tempObj[(num+1)] && num >= index) {
                tempObj[num] = tempObj[(num+1)]; 
                // update incentivesetupid 
                if (tempObj[num]['blank'] == false) {
                    tempObj[num]['incentivesetupid'] = num+1; 
                }   
            }
        }); 
        // remove last element 
        delete tempObj[length]; 
        // set state
        setRebateSetupDataList(rebateSetupDataList => rebateSetupDataList = tempObj); 
        // remove error object from error list
        setRebateSetupErrorList(rebateSetupErrorList => rebateSetupErrorList = [...rebateSetupErrorList.slice(0, index), ...rebateSetupErrorList.slice(index + 1, rebateSetupErrorList.length)]); 
        // decrement length
        setRebateSetupDataListLength(rebateSetupDataListLength => rebateSetupDataListLength = rebateSetupDataListLength - 1); 
    }

    // showCell for to determine how to display each column
    const showCell = ( el, tag ) =>{
        if (el == 'blank'){
            if (row[el] == true){
                return <TableCell colSpan={tableHeader.length} align='center' className='p-2 bg-white'>
                            <Button disableRipple onClick={()=>addRebateSetup()} 
                                sx={{width:'100%', background:'#E5F2F6' ,border:'#E5F2F6','&:hover': {
                                    backgroundColor: '#D9ECF2',
                                    },
                                    }}
                                >
                                {<div className='d-flex gap-2 align-items-center p-1'>
                                    <img src={addIcon}/>
                                    <Typography sx={{
                                        textTransform:'none',
                                        color:'#001317',
                                        fontFamily:'Roboto regular, Helvetica, Arial, sans-serif',
                                        fontSize:'12px',
                                        lineHeight:'16px',
                                        fontWeight:'400'}}>
                                            {'Add'}
                                    </Typography>
                                </div>}
                            </Button>
                        </TableCell>
            }
            else{
                return <TableCell><img src={redMinusIcon} class='data-table-icon-right' onClick={()=>removeRebateSetup(count)}/></TableCell>
            }
        } 
        else if (row['blank'] == false && el == 'active'){
            return <TableCell><TableDropdown tag={tag} objKey='active' count={count} list={rebateSetupDataList} setList={setRebateSetupDataList} length={rebateSetupDataListLength} optionsList={activeList} width='4.3vw'  showError={rebateSetupErrorList[count]['active']}/></TableCell>
        }
        else if (row['blank'] == false && el == 'masterincentivesetupid'){
            // if is master setup do not allow input for master setup
            if (!masterSetupBool){
                return <TableCell><TableAutocomplete tag={tag} objKey={'masterincentivesetupid'} count={count} list={rebateSetupDataList} setList={setRebateSetupDataList} length={rebateSetupDataListLength} optionsList={masterTierIdsList} width='5.6vw'  showError={rebateSetupErrorList[count]['masterincentivesetupid']} nullifyEmpty={true}/></TableCell>
            }
            else {
                return <TableCell></TableCell>
            }
        }
        else if (row['blank'] == false && el == 'companyid'){
            // if adding setup to all sub companies do not allow input for sub company id
            if (!setupToAllSubs){
                return <TableCell><TableAutocomplete tag={tag} objKey='companyid' count={count} list={rebateSetupDataList} setList={setRebateSetupDataList} length={rebateSetupDataListLength} optionsList={subCompanyIdsList} width='12vw'  showError={rebateSetupErrorList[count]['companyid']} nullifyEmpty={false}/></TableCell>
            }
            else {
                return <TableCell></TableCell>
            }
             
        }
        else if (row['blank'] == false && el == 'incentivesetupid'){
            return <TableCell><PageReadOnlyInput tag={tag} value={setupId} width='40px' /></TableCell>
        }
        else if (row['blank'] == false && el == 'producttypeid'){
            return <TableCell><TableDropdown tag={tag} objKey='producttypeid' count={count} list={rebateSetupDataList} setList={setRebateSetupDataList} length={rebateSetupDataListLength} optionsList={productTypeList} width='5.6vw'  showError={rebateSetupErrorList[count]['producttypeid']}/></TableCell>
        }
        else if (row['blank'] == false && el == 'feecategoryid'){
            return <TableCell><TableDropdown tag={tag} objKey='feecategoryid' count={count} list={rebateSetupDataList} setList={setRebateSetupDataList} length={rebateSetupDataListLength} optionsList={feeCategoryDescriptionList} width='8vw'  showError={rebateSetupErrorList[count]['feecategoryid']}/></TableCell>
        }
        else if (row['blank'] == false && el == 'billingrateid'){
            return <TableCell><TableDropdown tag={tag} objKey='billingrateid' count={count} list={rebateSetupDataList} setList={setRebateSetupDataList} length={rebateSetupDataListLength} optionsList={billingRateList} width='5.6vw'  showError={rebateSetupErrorList[count]['billingrateid']}/></TableCell>
        }
        else if (row['blank'] == false && el == 'minspend'){
            return <TableCell><TableInput tag={tag} objKey={'minspend'} count={count} list={rebateSetupDataList} setList={setRebateSetupDataList} length={rebateSetupDataListLength} width='12vw'  showError={rebateSetupErrorList[count]['minspend']} /></TableCell>
        }
        else if (row['blank'] == false && el == 'maxspend'){
            return <TableCell><TableInput tag={tag} objKey={'maxspend'} count={count} list={rebateSetupDataList} setList={setRebateSetupDataList} length={rebateSetupDataListLength} width='12vw'  showError={rebateSetupErrorList[count]['maxspend']} /></TableCell>
        }
        else if (row['blank'] == false && el == 'incentiverate'){
            // if is master setup do not allow input for incentiverate
            if (!masterSetupBool){
                return <TableCell><TableInput tag={rateTag} objKey={'incentiverate'} count={count} list={rebateSetupDataList} setList={setRebateSetupDataList} length={rebateSetupDataListLength} nullifyEmpty={true} width='8vw'  showError={rebateSetupErrorList[count]['incentiverate']}/></TableCell>
            }  
            else {
                return <TableCell></TableCell>
            } 
        }
        else if (row['blank'] == false && el == 'mastersetupbool'){
            return <TableCell><FormControlLabel
                value="end"
                control={<Checkbox
                    sx={{
                        color: '#000000',
                        '&.Mui-checked': {
                        color: '#000000',
                        },
                    }} />}
                label=""
                labelPlacement="end"
                sx={{
                    color: 'black',
                    margin: 'auto', 
                    marginTop: '-5px', 
                }}
                checked={masterSetupBool}
                onChange={(e)=>{
                    // set state 
                    setMasterSetupBool(masterSetupBool => masterSetupBool = e.target.checked); 
                    // set object
                    let temp = rebateSetupDataList; 
                    temp[count]['mastersetupbool'] = e.target.checked; 
                    setRebateSetupDataList(rebateSetupDataList => rebateSetupDataList = temp); 
                }}
            /></TableCell>
        }
        else if (row['blank'] == false && el == 'rebatesetuptypeid') {
            return <TableCell><TableDropdown tag={tag} objKey='rebatesetuptypeid' count={count} list={rebateSetupDataList} setList={setRebateSetupDataList} length={rebateSetupDataListLength} optionsList={rebateSetupTypeList} width='8vw'  showError={rebateSetupErrorList[count]['rebatesetuptypeid']}/></TableCell>
        }
        else {
            return <>{row[el]}</>
        }
    }

    // useEffect to make updates on masterSetupBool toggle
    useEffect(() => {
        if (row['blank'] == false && masterSetupBool) {
            // if master setup id add to master tier ids list  
            setMasterTierIdsList(masterTierIdsList => masterTierIdsList = [
                ...masterTierIdsList.slice(0, count), 
                setupId.toString(), 
                ...masterTierIdsList.slice(count + 1, masterTierIdsList.length), 
            ]); 
            // nullify masterSetupId and rebateRate
            let temp = rebateSetupDataList; 
            rebateSetupDataList[count]['masterincentivesetupid'] = null; 
            rebateSetupDataList[count]['incentiverate'] = null; 
            setRebateSetupDataList(rebateSetupDataList => rebateSetupDataList = temp);  
        }
        else if (row['blank'] == false) {
            // if not master setup id remove from master tier list 
            setMasterTierIdsList(masterTierIdsList => masterTierIdsList = [
                ...masterTierIdsList.slice(0, count), 
                ...masterTierIdsList.slice(count + 1, masterTierIdsList.length), 
            ]); 
        }
    }, [masterSetupBool]); 

    // useEffect for rebateInputTypeId change
    useEffect(() => {
        if (rebateInputTypeId == 1){
            setRateTag(rateTag => rateTag = 'Rate (%)'); 
        }
        else {
            setRateTag(rateTag => rateTag = 'Rate '); 
        }
    }, [rebateInputTypeId]); 

    return( 
        <>
            {/* map show cell function over every column */}
            {tableHeader.map(el => 
                showCell(el['columnname'], el['columntag'])
            )}
        </>
    );
}

export default AddNewRebateSetupRow;